module.exports = "<cat-explorer\n    [items]=\"explorerItems\"\n    [displayCreate]=\"doAllowCreate\"\n    [activeItem]=\"currentActiveItem\"\n    (onActivate)=\"navigateTo($event)\"\n></cat-explorer>\n<cat-section-content>\n    <cat-mainarea>\n        <router-outlet></router-outlet>\n    </cat-mainarea>\n</cat-section-content>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/userdata-generation/userdata-generation.component.html
// module id = ../../../../../src/app/modules/project-details/components/userdata-generation/userdata-generation.component.html
// module chunks = main